import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContacts = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "question-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc7 {\n        fill: #0573A9;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "secc7",
			d: "M7.00104,2.06403c-1.44458,0-2.61566,1.17108-2.61566,2.61566h1.30829c-.00061-.02356-.00061-.04712,0-.07062.01953-.72229.62085-1.29199,1.34314-1.27252.72229.01953,1.29199.62085,1.27252,1.34314,0,1.30731-1.96198,1.14441-1.96198,3.26929h1.30927l-.00098-.00098c0-1.47119,1.96198-1.63416,1.961-3.26831,0-1.44458-1.17102-2.61566-2.6156-2.61566Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc7",
			d: "M7.32599.1087C3.89899-.07129.97491,2.56097.79498,5.98792c-.17999,3.427,2.45221,6.35101,5.87921,6.53101v2.35168l.93573-.44781c3.35406-1.61511,5.60382-4.8692,5.60382-8.10895C13.21375,3.00879,10.62646.28204,7.32599.1087ZM7.98248,12.72192v-1.50366h-.98047c-2.70868,0-4.90448-2.1958-4.90448-4.90442S4.29333,1.40942,7.00201,1.40942c2.70819.00104,4.90332,2.19623,4.90442,4.90442-.15094,2.65881-1.62433,5.065-3.92395,6.40808Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc7",
			d: "M6.96613,8.74976c-.40857,0-.71503.30646-.71503.71503s.30646.71503.71503.71503.71503-.30646.71503-.71503-.30646-.71503-.71503-.71503Z"
		})
	]
});
export default SvgContacts;
